import { render, staticRenderFns } from "./black_list.vue?vue&type=template&id=4ea286ec"
import script from "./black_list.vue?vue&type=script&lang=ts"
export * from "./black_list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports